<button
  mat-button
  type="button"
  color="primary"
  class="rounded-pill px-2 d-inline-flex align-items-center gap-1"
  (click)="autoTranslate()"
  [disabled]="!canTranslate()">
  @if (isTranslating) {
    <ng-container>
      <mat-icon class="fs-6">sync</mat-icon>
      <span class="small">Translating…</span>
    </ng-container>
  } @else {
    <ng-container>
      <mat-icon class="fs-6">translate</mat-icon>
      <span class="small">Auto-translate</span>
    </ng-container>
  }
</button>

@if (isQuotaReached) {
  <small class="text-muted ms-1">Quota reached for this month.</small>
}

@if (message) {
  <small class="text-warning ms-1">{{ message }}</small>
}
